import http from './http';
import OrganizationService from './OrganizationService';
// import { wOrgIdMiddleware } from '../utils/commonUtils';
import { UNPROCESSABLE_CONTENT } from '../utils/constant';

const PatientFormService = {
  sentPatientQuestionnaire:async (data)=>{
    try {
        const response = await http.POST(`patient-send-questionnaire`, data)
        if (response.code === 200 && response.data) {
        return response.data;
      }
      
      return response;
    } catch (error) {
      // console.error('Error fetching user:', error);
      throw error;
    }
  },
  saveEmrHistory:async (org_id,visit_id,data)=>{
    try {
        const response = await http.POST(`organizations/${org_id}/save-all-history/${visit_id}`, data)
        if (response.code === 200 && response.data) {
        return response.data;
      }
      
      return response;
    } catch (error) {
      // console.error('Error fetching user:', error);
      throw error;
    }
  }, 
    sentPatientFormEmail:async (data)=>{
    try {
        const response = await http.POST(`patient-form`, data)
        if (response.code === 200 && response.data) {
        return response;
      }
      
      return response;
    } catch (error) {
      // console.error('Error fetching user:', error);
      throw error;
    }
  },
  //Save user
  getPatientFormsById: async (id)=>{
    try {
      const response = await http.GET(`patient-form/${id}`,)
      // console.log('response',response);
      
      if ((response.code === 200 || response.code === 201) && response.data) {
        return response.data;
      } else {
        return response;
      }
      
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  },
  /** Staff: latest intake form UUID for a visit (kiosk launch). Requires patient form to exist. */
  getLatestPatientFormByVisit: async (visitId) => {
    try {
      const orgId = OrganizationService.getOrgId();
      if (!orgId) {
        return { code: 400, data: { message: 'Organization not selected' } };
      }
      const response = await http.GET(
        `organizations/${orgId}/patient-form-by-visit/${visitId}`
      );
      return response;
    } catch (error) {
      console.error('Error fetching patient form by visit:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      return error;
    }
  },
  getFullHistoryFormsById: async (org_id,id)=>{
    try {
      const response = await http.GET(`organizations/${org_id}/emr-structure/${id}`,)
      // console.log('response',response);
      
      if ((response.code === 200 || response.code === 201) && response.data) {
        return response;
      } else {
        return response;
      }
      
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  },
  savePatientForm:async(data,headers={})=>{
    try {
      const response = await http.POST(`save-patient-form`,data,headers)      
      if ((response.code === 200 || response.code === 201) && response.data) {
        return response.data;
      } else {
        return response;
      }
      
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  },
  saveActivityConsentForm:async(maping_id,data)=>{
    try {
      const response = await http.POST(`save-activity-consent/${maping_id}`,data)      
      if ((response.code === 200 || response.code === 201) && response.data) {
        return response.data;
      } else {
        return response;
      }
      
    } catch (error) {
      console.error('Error fetching user:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  },
  patientFormLogin:async(data, headers = {})=>{
    try {
      const response = await http.POST('patient-form-login', data,headers);
      return response;
      
    } catch (error) {
      if (error.status === UNPROCESSABLE_CONTENT) {
        return error.data;
      }
      //   throw error;
    }
},
patientFormLogin_md:async(data, headers = {})=>{
    try {
      const response = await http.POST('patient-form-login-md', data,headers);
      return response;
      
    } catch (error) {
      if (error.status === UNPROCESSABLE_CONTENT) {
        return error.data;
      }
      //   throw error;
    }
},
getAllPatinetForm: async () => {
  try {
    const response = await http.GET('get-all-patient-form');
    return response;

  } catch (error) {
    if (error.status === UNPROCESSABLE_CONTENT) {
      return error.data;
    }
    //   throw error;
  }
},
 getPatientFormStatus:async()=>{
  try {
    const response = await http.GET('get-patient-form-status');
    return response;

  } catch (error) {
    if (error.status === UNPROCESSABLE_CONTENT) {
      return error.data;
    }
    //   throw error;
  }
    
},
validatePatientForm:async(id=null, options = {})=>{
  try {
    const query =
      options.reentryMode || options.reviewMode ? "?reentry=1&review_mode=1" : "";
    const response = await http.GET(`validate-patient-form/${id}${query}`);
    return response.data;

  } catch (error) {
    if (error.status === UNPROCESSABLE_CONTENT) {
      return error.data;
    }
    //   throw error;
  }
    
},
saveDemographicsVerification:async(data, headers = {})=>{
  try {
    const response = await http.POST(`save-demographics-verification`, data, headers);
    if ((response.code === 200 || response.code === 201) && response.data) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    console.error('Error saving demographics verification:', error);
    if (error.status === UNPROCESSABLE_CONTENT) {
      return error.data;
    }
    throw error;
  }
}
}

export default PatientFormService;